/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState} from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/
import { console_dev_line } from "./functions";
import firebase from 'firebase/app';
import 'firebase/messaging';

firebase.initializeApp({
    apiKey: "AIzaSyDWix_MwWm2SNqJcV-MKpbcsznWqWOdNy4",
    authDomain: "fir-4c41c.firebaseapp.com",
    projectId: "fir-4c41c",
    storageBucket: "fir-4c41c.appspot.com",
    messagingSenderId: "143190342903",
    appId: "1:143190342903:web:638c9b4cfaebba0d87e7f2"
});

const messaging = firebase.messaging();

messaging.onMessage((payload) => {
    // console_dev_line('----------------------------------------------------------');
    // console_dev_line('@root_fmc_notification');
    // console_dev_line('----------------------------------------------------------');
    // console_dev_line(payload)
});

const _initial = async () => {

    try {

        const token = await messaging.getToken();
        // console_dev_line('----------------------------------------------------------');
        // console_dev_line('@root_fmc_token');
        // console_dev_line('----------------------------------------------------------');
        // console_dev_line(token)
  
        return token;

  } catch (error) {
        console.error(error);
  }

}

_initial()